import { requests } from './baseServices'

export const UserService = {
    getAll: (criteria) => requests.get('api/users', criteria),
    getAllWithOptions: (criteria) => requests.post('api/users/filtered', criteria),
    getById: (id) => requests.get(`api/users/${id}`),
    getProfile: (id) => requests.get(`api/users/profile`),
    update: (id, user) => requests.put(`api/users/${id}`, user),
    updateProfile: (user) => requests.put(`api/users/profile/update`, user),
    create: (user) => requests.post(`api/users`, user),
    delete: (id) => requests.delete(`api/users/${id}`),
    search: (role, query) => requests.get('api/users/search', { role: role, query: query }),
    duplicate: (id) => requests.post(`api/users/duplicate/${id}`),
    message: (message) => requests.post(`api/users/message`, message),
    ignoreMessage: (id) => requests.delete(`api/users/message/${id}`),
    information: (info) => requests.post(`api/users/information`, info),
    notifications: () => requests.get(`api/users/notifications`),
    markNotificationAsRead: (id) => requests.put(`api/users/notification/read/${id}`),

    recoverPassword: (data) => requests.post(`api/users/recover-password`, data),
    changePassword: (data) => requests.put(`api/users/change-password`, data),
    sendEmail: (data) => requests.post(`api/users/email`, data),

    updateLanguage: (language) => requests.put(`api/users/update-language`, { language: language }),
};